module.exports = __webpack_public_path__ + "media/images/vp/samples/08-0802c0e1a356d0bff996116d75ec118a.jpg";